<div class="flex w-full my-4 mb-12 min-h-[120px]">
  <div class="w-1/2 mr-1 relative">
    <app-feature-list-container>
      <div class="flex justify-between">
        <h3 class="mb-6">{{ '+HEATING_HEATER.TITLE.FANRING' | translate }}</h3>
        <mat-slide-toggle
          gtm="onToggle"
          gtmAction="Turn feature on off"
          gtmCategory="toggleFanring"
          [checked]="fanRingFeature.fanRing.properties.active.value"
          (change)="switchFeature($event, featureNames.heatingHeaterFanring)"
        >
        </mat-slide-toggle>
      </div>
      <p>{{ '+HEATING_HEATER.TITLE.FANRING_DESCRIPTION' | translate }}</p>
    </app-feature-list-container>
  </div>
  <div class="w-1/2 ml-1">
    <app-feature-list-container>
      <div class="flex justify-between">
        <h3 class="mb-6">{{ '+HEATING_HEATER.TITLE.CONDENSATE_PAN_HEATER' | translate }}</h3>
        <mat-slide-toggle
          gtm="onToggle"
          gtmAction="Turn feature on off"
          gtmCategory="toggleCondensatePan"
          [checked]="fanRingFeature.condensatePan.properties.active.value"
          (change)="switchFeature($event, featureNames.heatingHeaterCondensatePan)"
        >
        </mat-slide-toggle>
      </div>
      <p>{{ '+HEATING_HEATER.TITLE.CONDENSATE_PAN_HEATER_DESCRIPTION' | translate }}</p>
    </app-feature-list-container>
  </div>
</div>
